// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3vFB4","containerItemsCenter":"Skeleton_containerItemsCenter__1OlTR"};